import type { Components } from '@mui/material/styles';

export default function MUIAppBar(): Components['MuiAppBar'] {
  return {};
}
